<template>
  <span :style="styleObject">{{ formattedText }}</span>
</template>
<script lang="ts">
import { formatMoney, formatNumber } from '@/legacy/store/helpFunctions'

export default {
  name: 'Difftext',
  props: {
    cost: Number,
    baseCost: Number,
    type: { type: String, validator: (t) => t === 'cpc' || t === 'cpa' },
  },
  computed: {
    formattedText: function () {
      let formattedText = ''
      if (this.cost !== null && this.baseCost !== null && this.cost !== this.baseCost) {
        const diff = this.cost - this.baseCost
        const prefix = diff > 0 ? '+' : '−'
        const formattedCost = this.type === 'cpc' ? formatMoney(Math.abs(diff)) : formatNumber(Math.abs(diff))
        formattedText = '(' + prefix + formattedCost + ')'
      }

      return formattedText
    },
    styleObject: function () {
      let color = 'black'
      if (this.cost !== null && this.baseCost !== null && this.cost !== this.baseCost) {
        const diff = this.cost - this.baseCost
        if (diff > 0) {
          color = '#2F7B50'
        } else {
          color = '#d33131'
        }
      }

      return { color }
    },
  },
}
</script>
